import { render, staticRenderFns } from "./RcvL_List.vue?vue&type=template&id=c476d772"
import script from "./RcvL_List.vue?vue&type=script&lang=js"
export * from "./RcvL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports